module.exports = __webpack_public_path__ + "static/media/44550234_2199894000085779_1264654370142683136_o.cc9df12f.jpg";